export const blockIconsCommonactionsVisibilityNew = (
	<span className='material-symbols-outlined'>visibility</span>
);
